import React from "react";

import { AuthLayout } from "@/components/layouts";

import { PasswordResetForm } from "./PasswordResetForm";

export const PasswordResetView = () => (
  <AuthLayout title="Reset your password">
    <PasswordResetForm />
  </AuthLayout>
);
